// extracted by mini-css-extract-plugin
export default {"alfa":"Gabarit_alfa__yypyB","btadd":"Gabarit_btadd__2RHK5","creer":"Gabarit_creer__fEIQM","comtnet":"Gabarit_comtnet__7k3m+","fontSize":"Gabarit_fontSize__ubnBw"};